import { ref } from 'vue'
import { defineStore } from 'pinia'
import { usePartsStore } from '@/stores/parts'
import { usePartStore } from '@/stores/part'
import { useTracePartsStore } from '@/stores/tracepart'
import { useFilterStore } from '@/stores/filter'
import { useCartStore } from '@/stores/cart'

export const useGlobalStore = defineStore('global', () =>
{
    const homeBase = ref(window.app.partnumber_search_extended.base)
    const entryLink = ref(window.app.partnumber_search_extended.entryLink)
    const apiBase = ref(window.app.partnumber_search_extended.api_base)
    const privacylink = ref(window.app.partnumber_search_extended.privacylink)
    const languageIsocode = window.app.partnumber_search_extended.language
    const locale = window.app.partnumber_search_extended.locale.replace('-', '_')
    const initialized = ref(false)
    const loading = ref(false)
    const lazyLoading = ref(false)
    const firstCalled = ref(false)
    const error = ref(false)
    const stage = ref(window.app.partnumber_search_extended.stage)
    const expressLink = ref(window.app.partnumber_search_extended.expresslink)
    const channel = ref(window.app.partnumber_search_extended.channel)

    let partsStore = usePartsStore()
    let partStore = usePartStore()
    let tracepartStore = useTracePartsStore()
    let filterStore = useFilterStore()
    let cartStore = useCartStore()

    function setPredefinedFilter ()
    {
        // get params from url
        const url = new URL(window.location.href)

        if (url.searchParams.has('searchTerm')) {
            filterStore.searchTerm = url.searchParams.get('searchTerm')
        }
        filterStore.prepareSelectedFilter()

        if (filterStore.filters) {
            for (const [key] of Object.entries(filterStore.filters))
            {
                if (url.searchParams.has(key)) {
                    let arr = url.searchParams.get(key).split(',')
                    for (const filter of arr)
                    {
                        if (filterStore.filters[key].options[0].searchTerm) {
                            let el = filterStore.filters[key].options.filter(el => el.searchTerm === filter)[0]
                            filterStore.selectedFilters[key].push({searchTerm: el.searchTerm, value: el.value})
                        }

                    }

                } else if (url.searchParams.has(key + '[min]'))
                {
                    if (filterStore.rangeFilters[key].options[0].min) {
                        filterStore.rangeFilters[key].options[0] = {'min': url.searchParams.get(key + '[min]'), 'type': 'range'}
                        filterStore.rangeFilters[key].options[1] = {'max': url.searchParams.get(key + '[min]'), 'type': 'range'}
                    }
                }
            }
        }
    }

    function pushState () {
        // set params to url
        const url = new URL(window.location.href)

        // delete all existing params
        if (filterStore.filters) {
            for (const [key] of Object.entries(filterStore.filters))
            {
                if (url.searchParams.has(key)) {
                    url.searchParams.delete(key)
                    url.searchParams.delete(key+ '[min]')
                    url.searchParams.delete(key+ '[max]')
                }
                if (url.searchParams.has(key + '[min]')) {
                    url.searchParams.delete(key+ '[min]')
                    url.searchParams.delete(key+ '[max]')
                }
            }
        }

        // add all params from store
        url.searchParams.set('searchTerm', filterStore.searchTerm)
        if (filterStore.selectedFilters) {
                for (const [key] of Object.entries(filterStore.selectedFilters))
                {
                    if (filterStore.selectedFilters[key].length)
                    {
                        let arr = []
                        for (const filter of filterStore.selectedFilters[key])
                        {
                            arr.push(filter.searchTerm)
                        }
                        url.searchParams.set(key, arr)
                    }
                }
        }
        if (filterStore.rangeFilters) {
            for (const [group] of Object.entries(filterStore.rangeFilters))
            {
                if (filterStore.rangeFilters[group].options.length)
                {
                        if (filterStore.rangeFilters[group].options[0].min === filterStore.rangeFilters[group].options[1].max)
                        {
                            url.searchParams.set(group + '[min]', filterStore.rangeFilters[group].options[0].min)
                            url.searchParams.set(group + '[max]', filterStore.rangeFilters[group].options[0].min)
                        }
                }
            }
        }
        window.history.pushState({}, '', url)
    }

    function filter ()
    {
        pushState()
        partsStore.getItems()
    }

    async function init ()
    {
        const url = new URL(window.location.href)
        if (url.searchParams.has('cHash')) {
            url.searchParams.delete('cHash')
            window.history.pushState({}, '', url)
        }

        await partsStore.getItems()
        setPredefinedFilter()
        Promise.all([
            partsStore.getItems()
        ]).then(() =>
        {
            cartStore.init()
            firstCalled.value = true
            initialized.value = true
            loading.value = false
        })
    }

    async function initDetailPage (id)
    {
        const url = new URL(window.location.href)
        if (url.searchParams.has('cHash')) {
            url.searchParams.delete('cHash')
            window.history.pushState({}, '', url)
        }
        firstCalled.value = true
        loading.value = true
        partStore.clearDetailItem()
        await partStore.getDetailItem(id)
        partStore.initImageSwiper()
        lazyLoading.value = true
        await tracepartStore.getCadFormatAvailable(id)
        partStore.initImageSwiperViewer()
        cartStore.init()
        loading.value = false
        initialized.value = true
    }

    function fillUpLength (length)
    {
        return length.toString().padStart(6, '0')
    }

    return {
        apiBase,
        privacylink,
        loading,
        locale,
        homeBase,
        initialized,
        languageIsocode,
        firstCalled,
        lazyLoading,
        error,
        stage,
        init,
        initDetailPage,
        pushState,
        filter,
        fillUpLength,
        entryLink,
        expressLink,
        channel
    }
})
